<template>
  <div v-if="activeLinkedProducts === null">
    <h4 class="linked--header">
      Linked Products
    </h4>
    <div class="d-flex flex-column">
      <img
        src="~@/assets/media/icons/close.svg"
        alt="close icon"
        class="icon--close"
        @click="$emit('close')"
      />
      <div class="d-flex">
        <div class="linked--info">
          <img src="~@/assets/media/icons/info.svg" alt="info icon" />
        </div>
        <p class="linked--description">
          Linking two products will prevent them from being booked at the same
          time. When one product is booked, the other linked product will be
          unavailable. Products can only be linked within the same location.
        </p>
      </div>
      <form
        @submit="submitForm($event)"
        v-if="!isLoading"
        class="form--link-product"
      >
        <div class="form-group position-relative">
          <label for="product">Location </label>
          <SelectDropdown
            label="Select location"
            :lists="locations"
            :selected="data.location"
            :multiple="false"
            @handleToggle="handleToggleLocation"
          />
        </div>
        <div class="form-group position-relative products-dropdown">
          <label for="product">Products</label>
          <SelectDropdown
            label="Select products"
            :error="
              (data.products !== null && data.products.length === 0) ||
                !!error.product
            "
            :lists="products"
            :disabled="!data.location"
            :selected="data.products"
            :disabledCheckbox="disabledCheckbox"
            @removeItem="removeItem"
            @handleToggle="handleToggle"
          />
          <span
            class="invalid"
            v-if="
              (data.products !== null && data.products.length === 0) ||
                !!error.product
            "
          >
            Please select a minimum of 2 products
          </span>
        </div>
        <div class="form-group">
          <label for="product">Link Name </label>
          <input
            name="product"
            type="text"
            v-model.trim="data.name"
            placeholder="Enter link name"
            v-validate.persist="'required|max:50'"
            data-vv-as="Link name"
            :disabled="!data.location"
            class="form-control input__link-name"
          />
          <div v-if="veeErrors.first('product')" class="invalid-feedback">
            {{
              data.name === "" || error.name
                ? "Please fill out this field"
                : "Please enter a maximum of 50 characters"
            }}
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <ActionButton
            class="btn-create"
            type="submit"
            :label="null"
            :disabled="
              !(data.products && data.products.length) ||
                !(data.location && data.location.length) ||
                data.products.length !== 2 ||
                !data.name ||
                data.name.length > 50 ||
                loader
            "
          >
            <p>Create Link</p>
          </ActionButton>
        </div>
      </form>
      <div class="table--current mt-4">
        <table v-if="linkedProducts && linkedProducts.length" class="table">
          <thead>
            <tr>
              <th class="table--head">Date Created</th>
              <th class="table--head">Link Name</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(lProduct, key) in linkedProducts"
              :key="key"
              class="table--row"
              @click="() => editLinkedProducts(lProduct)"
            >
              <td>{{ formatDate(lProduct.createdAt, "MMM DD, YYYY") }}</td>
              <td>{{ lProduct.name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div v-else-if="!isDelete" class="d-flex flex-column">
    <div class="d-flex align-center relative">
      <button
        v-if="!isNameEditing"
        type="button"
        class="btn--back"
        @click="backBtn"
      >
        <img
          src="~@/assets/media/icons/icon-down-arrow.svg"
          alt="info icon"
          :class="['btn--back__icon']"
        />
      </button>
      <div :class="['d-flex flex-column w-100', { 'ml-2': !isNameEditing }]">
        <div class="d-flex align-items-center w-100">
          <div
            class="form-group edit--header__form-group"
            v-if="isNameEditing && activeLinkedProducts"
          >
            <input
              ref="productName"
              name="linkName"
              type="text"
              class="edit--header form-control edit--header__input w-100"
              v-model.trim="linkNameEdit"
              v-validate.persist="'max:50'"
              data-vv-as="Product link name"
              @blur="clickedOutside"
            />
            <div v-if="veeErrors.first('linkName')" class="invalid-feedback">
              Please enter a maximum of 50 characters
            </div>
          </div>
          <template v-if="!isNameEditing">
            <h4 class="edit--header">
              {{ activeLinkedProducts.name }}
            </h4>
            <div class="edit--header__action">
              <button
                type="button"
                class="btn--edit"
                @click="
                  () => {
                    isNameEditing = true;
                    linkNameEdit = activeLinkedProducts.name;
                    $validator.reset();
                  }
                "
              >
                <img
                  src="~@/assets/media/icons/edit-icon.svg"
                  alt="close icon"
                  class="icon--mod"
                />
                <span>Edit Link Name</span>
              </button>
              <button
                type="button"
                class="btn--delete"
                @click="isDelete = true"
              >
                <img
                  src="~@/assets/media/icons/delete-icon.svg"
                  alt="close icon"
                  class="icon--mod"
                />
                <span>Delete Link</span>
              </button>
            </div>
          </template>
        </div>
        <p v-if="!isNameEditing" class="edit--subheader">
          {{ `Location: ${activeLinkedProducts.Location.name}` }}
        </p>
        <p v-if="!isNameEditing" class="edit--subheader mt-0">
          {{
            `Date Created: ${formatDate(
              activeLinkedProducts.createdAt,
              "MMM DD, YYYY"
            )}`
          }}
        </p>
      </div>
      <img
        src="~@/assets/media/icons/close.svg"
        alt="close icon"
        class="icon--close"
        @click="$emit('close')"
      />
    </div>
    <div
      v-if="!disabledCheckbox"
      class="form-group position-relative field--container"
    >
      <label for="product">Products</label>
      <SelectDropdown
        label="Select products"
        :disabled="
          (data.products !== null && data.products.length === 0) ||
            !!error.product
        "
        :disabledCheckbox="disabledCheckbox"
        :lists="products"
        :selected="data.products"
        @removeItem="removeItem"
        @handleToggle="handleToggle"
      />
      <span
        class="invalid"
        v-if="
          (data.products !== null && data.products.length === 0) ||
            !!error.product
        "
      >
        Please fill out this field
      </span>
    </div>
    <div v-if="!disabledCheckbox" class="d-flex justify-content-end">
      <ActionButton
        class="btn--add"
        type="button"
        :label="null"
        :theme="{ primary, secondary, event, danger }"
        :disabled="!(data.products && data.products.length) || loader"
        @customEvent="addExisting"
      >
        <p>Add</p>
      </ActionButton>
    </div>
    <div class="table--current mt-4">
      <table
        v-if="
          activeLinkedProducts.ProductLinks &&
            activeLinkedProducts.ProductLinks.length
        "
        class="table"
      >
        <thead>
          <tr>
            <th class="table--head">Products</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(lProduct, key) in activeLinkedProducts.ProductLinks"
            :key="key"
            :class="[
              `table--row`,
              {
                'item--products': activeLinkedProducts.ProductLinks.length > 2
              },
              { 'pointer-none': activeLinkedProducts.ProductLinks.length <= 2 }
            ]"
          >
            <td>
              <div class="d-flex justify-content-between">
                <span>{{ lProduct.Product.name }}</span>
                <button
                  class="delete--link-product"
                  @click="() => removeSavedItem(lProduct.Product.id)"
                >
                  <img
                    v-if="activeLinkedProducts.ProductLinks.length > 2"
                    src="~@/assets/media/icons/trash.svg"
                    alt="close icon"
                    class="icon--trash"
                  />
                  <div class="tooltipText">
                    <p>Remove</p>
                  </div>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-else class="d-flex flex-column">
    <img
      src="~@/assets/media/icons/close.svg"
      alt="close icon"
      class="icon--close"
      @click="$emit('close')"
    />
    <div class="d-flex flex-column align-items-center">
      <h3 class="delete--title">
        {{
          `Are you sure you want to delete ‘${activeLinkedProducts.name}’ link?`
        }}
      </h3>
      <p class="delete--description">This cannot be undone.</p>
      <div class="d-flex mt-4">
        <ActionButton
          label="Cancel"
          :theme="{ primary, secondary, event, danger }"
          style="display: inline-block; width: auto; margin-top: 0; font-size: 0.75rem; margin-right: 1rem;"
          mode="outline"
          @customEvent="isDelete = false"
        />
        <ActionButton
          label="Delete"
          :theme="{ primary, secondary, event, danger }"
          style="display: inline-block; width: auto; margin-top: 0; font-size: 0.75rem;"
          @customEvent="handleDelete"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import ActionButton from "@/components/ActionButton";
import SelectDropdown from "@/components/SelectDropdown";
import axios from "@/helpers/axios";
import { mapActions } from "vuex";

export default {
  name: "LinkedProducts",
  components: {
    ActionButton,
    SelectDropdown
  },
  data: () => ({
    data: {
      location: null,
      products: null,
      name: null
    },
    error: {
      product: "",
      name: ""
    },
    api: {
      page: 1,
      size: 500,
      action: "orderBy=id:DESC,productLinkSort"
    },
    products: [],
    locations: [],
    isLoading: true,
    loader: false,
    linkedProducts: [],
    isNameEditing: false,
    linkedProductsLoader: true,
    activeLinkedProducts: null,
    linkNameEdit: "",
    isDelete: false,
    oldLinkName: ""
  }),
  created() {
    this.init();
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    },
    user() {
      return this.$store.getters.getFullUser;
    },
    disabledCheckbox() {
      const selectedProducts = this.data.products ? this.data.products : [];
      const linkedProducts =
        this.activeLinkedProducts && this.activeLinkedProducts.ProductLinks
          ? this.activeLinkedProducts.ProductLinks
          : [];
      const totalSelectedProducts =
        selectedProducts.length + linkedProducts.length;

      return totalSelectedProducts > 1;
    }
  },
  watch: {
    isNameEditing(value) {
      if (value) {
        const val = this;
        setTimeout(() => {
          val.$refs.productName.focus();
        }, 200);
      }
    }
  },
  methods: {
    async init() {
      await this.fetchLocation();
      await this.fetchLinkedProducts();
    },
    ...mapActions({
      FETCH_COLLECTION_PER_PAGE: "FETCH_COLLECTION_PER_PAGE"
    }),
    formatDate(date, type) {
      return format(date, type);
    },
    async handleReloadPage() {
      const { page, size, action } = this.api;
      await this.FETCH_COLLECTION_PER_PAGE(this.pagelink(page, size, action));
    },
    pagelink(page, size = 500, action = "orderBy=productLinkSort,id:DESC") {
      return `/products?page[number]=${page}&page[size]=${size}&${action}`;
    },
    async fetchLocation() {
      await axios
        .get(`/locations?page[number]=1&page[size]=500&orderBy=id:DESC`)
        .then(response => {
          var { data } = response.data;

          data = data.map(location => ({
            label: location.name,
            value: location.id,
            toggle: false
          }));
          this.locations = [...data];
        });
    },
    async paginated(existing, locationId) {
      const getLinkedIds = existing.reduce((acc, curr) => {
        const parseId = curr.ProductLinks;
        parseId.forEach(v => {
          acc.push(v.productId);
        });
        return acc;
      }, []);
      await axios
        .get(
          `/products?page[number]=${this.api.page}&page[size]=${this.api.size}&${this.api.action}&locationId=${locationId}`
        )
        .then(response => {
          var { data, meta } = response.data;
          data = data
            .filter(product => !getLinkedIds.includes(product.id))
            .map(product => ({
              label: product.name,
              value: product.id,
              toggle: false
            }));
          this.products = [...data];
          if (meta.hasNextPage) {
            this.paginated(existing, locationId);
            this.api.page = this.api.page + 1;
          }
        });
    },
    async fetchLinkedProducts() {
      const { data } = await axios.get(`/products/link/products`);
      this.linkedProducts = data.data;
      this.linkedProductsLoader = false;
      this.isLoading = false;
      return data.data;
    },
    async submitForm(event) {
      event.preventDefault();
      if (
        !this.data.name ||
        (this.data.products && this.data.products.length < 2)
      ) {
        if (!this.data.name) {
          this.error.name = "Please fill out this field";
        }
        if (this.data.products && this.data.products.length < 2) {
          this.error.product = "Please select a minimum of 2 products";
        }
        return;
      }
      this.error.name = null;
      this.error.product = null;
      const payload = {
        name: this.data.name,
        locationId: this.data.location[0].value,
        productLinks: this.data.products.map(v => v.value)
      };

      await axios.post(`/products/link`, payload).then(resp => {
        if (resp.status === 200) {
          this.$toastr.success("Successfully created link!", "Success");
          this.handleReloadPage();
          this.$emit("close");
        }
      });
    },
    async addExisting() {
      if (
        !this.data.products ||
        (this.data.products && this.data.products.length < 1)
      ) {
        this.error.product = "Please select a minimum of 1 products";
        return;
      }
      this.error.product = null;
      const payload = {
        addLinked: this.data.products.map(v => v.value)
      };

      await axios
        .patch(
          `/products/link/products/${this.activeLinkedProducts.id}`,
          payload
        )
        .then(resp => {
          if (resp.status === 200) {
            this.$toastr.success("Successfully updated link!", "Success");
            this.handleReloadPage();
            this.$emit("close");
          }
        });
    },
    async removeSavedItem(id) {
      if (!this.activeLinkedProducts.id && !id) return;
      const payload = {
        removeLinked: [id]
      };

      await axios.patch(
        `/products/link/products/${this.activeLinkedProducts.id}`,
        payload
      );
      this.handleReloadPage();
      this.api = {
        page: 1,
        size: 500,
        action: "orderBy=id:DESC"
      };
      const details = await this.fetchLinkedProducts();
      const currentData = details.find(
        d => d.id === this.activeLinkedProducts.id
      );
      this.activeLinkedProducts = currentData;
    },
    async editLinkedProducts(data) {
      await this.paginated(this.linkedProducts, data.Location.id);
      this.activeLinkedProducts = data;
      this.products = this.products.map(prod => ({ ...prod, toggle: false }));
      this.data.location = null;
      this.data.products = null;
      this.data.name = null;
      this.error.product = null;
      this.error.name = null;
      this.oldLinkName = data.name;
    },
    async clickedOutside(data) {
      if (data.target.value.length > 50) return;

      const payload = {
        name: data.target.value.trim()
          ? data.target.value.trim()
          : this.oldLinkName
      };

      await axios.patch(
        `/products/link/products/${this.activeLinkedProducts.id}`,
        payload
      );
      this.handleReloadPage();
      this.isNameEditing = false;
      this.activeLinkedProducts.name = payload.name;
      this.oldLinkName = payload.name;
    },
    backBtn() {
      this.activeLinkedProducts = null;
      this.products = this.products.map(prod => ({ ...prod, toggle: false }));
      this.data.products = null;
      this.data.location = null;
      this.data.name = null;
      this.error.product = null;
      this.error.name = null;
    },
    handleToggle(props) {
      const { key } = props;
      this.products[key].toggle = !this.products[key].toggle;
      this.data.products = this.products.filter(v => v.toggle);
      if (this.products.filter(v => v.toggle).length > 1) {
        this.error.product = null;
      }
    },
    async handleToggleLocation(props) {
      const { key } = props;
      this.locations = this.locations.map(prod => ({ ...prod, toggle: false }));
      this.locations[key].toggle = !this.locations[key].toggle;
      this.data.products = null;
      this.data.location =
        this.locations && this.locations.filter(v => v.toggle);
      const locationId = this.data.location[0].value;
      await this.paginated(this.linkedProducts, locationId);
    },
    async handleDelete() {
      const getId = this.activeLinkedProducts.id;
      await axios.delete(`/products/link/products/${getId}`).then(resp => {
        if (resp.status === 200) {
          this.$toastr.success("Successfully deleted link!", "Success");
          this.handleReloadPage();
          this.$emit("close");
        }
      });
    },
    removeItem(props) {
      const { e, val } = props;
      e.stopPropagation();
      this.data.products = this.data.products.filter(
        v => v.value !== val.value
      );
      this.products = this.products.map(v => {
        if (v.value === val.value) {
          v.toggle = false;
        }
        return v;
      });
      this.handleReloadPage();
    }
  }
};
</script>

<style lang="scss" scoped>
.linked--description {
  color: #4c4c4c;
  font-size: 12px;
  line-height: 18px;
  margin-left: 8px;
  width: calc(100% - 1.5rem);
  margin-bottom: 16px;
}

.linked--info {
  width: 16px;
  height: 16px;
  position: relative;
  display: flex;
  margin-top: 2px;

  img {
    width: 100%;
    height: 100%;
  }
}
.open-indicator:before {
  border-color: currentColor;
  border-width: 2px 2px 0 0;
  color: var(--primary, currentColor);
  height: 8px;
  transition: all 0.2s ease;
  width: 8px;
  content: "";
}

.table--head {
  font-size: 14px;
  color: #222731;
  font-weight: 600;
  text-transform: none;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 24px;
}

.table--row {
  border-radius: 4px;
  transition: 300ms;
  &:hover {
    cursor: pointer;
    background: #e7f9fc;
  }
  td {
    &:first-child {
      width: 168px;
    }
    color: #4c4c4c;
    font-size: 14px;
    padding-left: 8px;
    padding-right: 8px;
  }
}

.linked--header {
  color: $gray-900;
  font-size: 20px;
  margin-bottom: 28px;
  position: relative;
  span {
    font-family: "Gotham", sans-serif;
  }
}

.icon--close {
  position: absolute;
  right: 24px;
  cursor: pointer;
  top: 20px;
}

.btn--back {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  transition: 300ms;
  border: none;
  background: transparent;
  &:hover {
    cursor: pointer;
    background-color: #e6f3f4;
  }
  &__icon {
    height: 6.87px;
    width: 12px;
    transform: rotate(90deg);
  }
}

.btn--edit {
  font-size: 12px;
  color: #0ec5dd;
  border: none;
  background: transparent;
  margin: 0;
  margin-left: 34px;
  padding: 0;
  height: max-content;
  display: flex;
  align-items: center;

  &:hover span {
    text-decoration: underline;
    cursor: pointer;
  }
}

.btn--add {
  width: 75px;
  height: 40px;

  &:disabled {
    background-color: #b7b7b7 !important;
  }

  p {
    font-size: 14px;
    letter-spacing: 0px;
    color: #ffffff;
  }
}

.form--link-product {
  .form-group {
    margin-bottom: 8px;

    label {
      font-family: "Nunito Sans";
      font-size: 0.75rem;
      font-weight: 700;
      line-height: 1.125rem;
      letter-spacing: 0rem;
      color: #4c4c4c;
      margin-bottom: 8px;
    }
  }

  .btn-create {
    width: min-content;
    padding: 10px 24px;
    background: linear-gradient(206deg, #0ec5dd 0%, #06c76e 100%) !important;
    border-radius: 4px;
    margin-top: 8px;
    transition: none;

    &:hover {
      background: #0ec5dd 0% 0% no-repeat padding-box !important;
    }

    &:disabled {
      background: none !important;
      background-color: #b7b7b7 !important;
      cursor: not-allowed;
    }

    p {
      margin: 0;
    }
  }
}

.form-control {
  border: 1px solid #949494;
  &:focus {
    border-color: #00b3c1;
  }
  &.is-invalid {
    border-color: #fa533d;
  }
  &:disabled {
    background: #fff;
    border-color: #b7b7b7;
  }

  &.input__link-name {
    padding: 8px 16px;
    height: 40px;
    font-family: "Nunito Sans";
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.25rem;
    letter-spacing: 0rem;
    color: #4c4c4c;

    &::placeholder {
      color: #949494;
    }
  }
}

.btn--delete {
  border: none;
  background: transparent;
  margin: 0;
  margin-left: 8px;
  color: #4c4c4c;
  font-size: 12px;
  padding: 0;
  height: max-content;
  display: flex;
  align-items: center;

  &:hover span {
    text-decoration: underline;
    cursor: pointer;
  }
}

.field--container {
  margin-top: 32px;
}

.delete--link-product {
  position: relative;
  visibility: hidden;
  opacity: 0;
  display: flex;
  border: none;
  background-color: transparent;

  .tooltipText {
    z-index: 10;
    opacity: 0;
    content: "";
    visibility: hidden;
    transition: 300ms;
    position: absolute;
    background: #4c4c4c;
    height: auto;
    border-radius: 5px;
    top: 22px;
    right: -24px;
    padding: 4px 12px;
    p {
      color: #ffffff;
      white-space: normal;
      text-align: start;
      font-size: 12px;
      margin-bottom: 0;
    }
  }

  &:after {
    opacity: 0;
    content: "";
    visibility: hidden;
    transition: 300ms;
    position: absolute;
    border-style: solid;
    border-color: transparent transparent #4c4c4c transparent;
    border-width: 8px;
    top: 8px;
    left: 5px;
  }

  &:hover {
    .tooltipText,
    &:after {
      opacity: 1;
      visibility: visible;
    }
  }
  .icon--trash {
    transition: 300ms;
    pointer-events: none;
  }
}

.item--products {
  position: relative;
  cursor: default !important;
  &:hover .delete--link-product {
    visibility: visible;
    opacity: 100;
    pointer-events: all;
    cursor: pointer;
  }
}

.products-dropdown {
  /deep/.dropdown--list {
    max-height: 250px;
  }
}

.edit--header {
  color: $gray-900;
  font-size: 20px;
  margin-bottom: 0;
  line-height: 28px;
  word-break: break-all;

  &__action {
    display: flex;
    min-width: 220px;
  }

  &__form-group {
    width: 100%;
    margin-bottom: 0;
  }
  &__input {
    font-weight: 500;
    border: 1px solid #0ec5dd;
    border-radius: 4px;
    padding: 0 16px;
    height: 34px;
    max-width: unset;

    &.is-invalid {
      border-color: #ef5350;
    }
  }
}
.edit--subheader {
  color: #4c4c4c;
  font-size: 12px;
  margin-top: 6px;
  line-height: 18px;
  margin-bottom: 0;
}
.table--current {
  border-top: 1px solid #dddddd;
  display: flex;
}
.pointer-none {
  pointer-events: none;
}
.invalid {
  color: #fa533d;
  font-size: 12px;
  margin-top: 4px;
  margin-bottom: 0;
}
.delete--title {
  color: #232323;
  font-size: 20px;
  text-align: center;
  max-width: 400px;
  margin-bottom: 1rem;
}
.delete--description {
  font-size: 1rem;
  color: #4c4c4c;
  margin-bottom: 0;
}
.icon--mod {
  margin-right: 4px;
}
</style>
